import { useMemo } from 'react';
import { debounce } from 'es-toolkit';
import { evaluateFormulaRecursive } from './evaluate-formula-recursive';

const RECALCULATION_DEBOUNCE_MS = 50;

export const useEvaluateFormulasDebounced = () => {
  return useMemo(
    () =>
      debounce(
        (
          formulas: Record<string, string>,
          scope: Record<string, string | string[] | number | undefined>,
          callback: (res: Record<string, string>) => void
        ) => {
          const result: Record<string, string> = {};

          for (const [key, formula] of Object.entries(formulas)) {
            try {
              const value = evaluateFormulaRecursive(formula, formulas, scope);
              if (value) {
                result[key] = value;
              }
            } catch (e) {
              console.error(`Failed to evaluate formula for ${key}:`, e);
            }
          }

          callback(result);
        },
        RECALCULATION_DEBOUNCE_MS,
        { leading: false }
      ),
    []
  );
};
